<template>
  <v-app>
    <v-app-bar :prominent="progressIsPinned && !onPages" dark clipped-right clipped-left app>
      <v-app-bar-nav-icon @click="navOpen = !navOpen"></v-app-bar-nav-icon>
      <template>
        <v-speed-dial
          color="primary"
          direction="bottom"
          top
          right
          absolute
          v-show="!onPages"
          @click="dialog = !dialog"
        >
          <template v-slot:activator>
            <v-btn fab small color="primary">
              <v-icon>mdi-flash</v-icon>
            </v-btn>
          </template>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab dark color="grey" @click="openMovesDialog">
                <v-icon>mdi-strategy</v-icon>
              </v-btn>
            </template>
            <span>Moves</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab dark color="grey" @click="openOraclesDialog">
                <v-icon>mdi-crystal-ball</v-icon>
              </v-btn>
            </template>
            <span>Oracles</span>
          </v-tooltip>
          <!--<v-tooltip left>-->
          <!--<template v-slot:activator="{ on }">-->
          <!--<v-btn v-on="on" fab dark color="grey" @click="openMapDialog">-->
          <!--<v-icon>mdi-map-outline</v-icon>-->
          <!--</v-btn>-->
          <!--</template>-->
          <!--<span>Map</span>-->
          <!--</v-tooltip>-->
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab dark color="grey" @click="actionRoll">
                <v-icon>mdi-dice-6</v-icon>
              </v-btn>
            </template>
            <span>Action Roll</span>
          </v-tooltip>
        </v-speed-dial>
      </template>
      <v-row v-show="!onPages">
        <ProgressTrack
          v-if="progressIsPinned"
          :track="pinnedProgressTrack"
          on-dark
          small
        />
      </v-row>
    </v-app-bar>

    <v-navigation-drawer dark left v-model="navOpen" app clipped width="300">
      <PrimaryNav />
    </v-navigation-drawer>

    <!--
    <v-navigation-drawer left mini-variant permanent app clipped>
      <v-row>
        <VitalsHeader vital="health" />
        <VitalsHeader vital="spirit" />
        <VitalsHeader vital="supply" />
        <FooterMomentum />
      </v-row>
    </v-navigation-drawer>
    -->

    <v-footer app padless v-show="!onPages">
      <v-row dense>
        <v-col cols="12">
          <v-toolbar short>
            <NewEntry />
          </v-toolbar>
        </v-col>
      </v-row>
      <v-row dense align="start" justify="center">
        <v-spacer v-if="$vuetify.breakpoint.smAndUp" />
        <FooterStat stat="edge" />
        <FooterStat stat="heart" />
        <FooterStat stat="iron" />
        <FooterStat stat="shadow" />
        <FooterStat stat="wits" />
        <v-spacer v-if="$vuetify.breakpoint.smAndUp" />
      </v-row>
      <v-row dense align="start" justify="center">
        <VitalsHeader vital="health" />
        <VitalsHeader vital="spirit" />
        <VitalsHeader vital="supply" />
        <FooterMomentum />
      </v-row>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            fab
            small
            right
            top
            @click="showCharacterSheet = !showCharacterSheet"
          >
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>
        </template>
        <span>Open Character Sheet</span>
      </v-tooltip>
    </v-footer>

    <v-bottom-sheet v-model="showCharacterSheet" no-overlay>

      <v-sheet height="90vh" style="overflow-y: auto;">
        <v-toolbar>
          <v-row>
            <v-icon color="red">mdi-heart</v-icon>ing this?
            <span class="ml-1"
              ><a href="https://www.buymeacoffee.com/vcavallo" target="_blank"
                >buy me a
                <v-icon color="orange">mdi-glass-mug-variant</v-icon></a
              ></span
            >
          </v-row>
          <v-toolbar-title>
            <v-btn
              fab
              icon
              small
              right
              absolute
              @click="showCharacterSheet = !showCharacterSheet"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-title>

          <template v-slot:extension>
            <v-tabs v-model="tab" centered show-arrows>
              <v-tab>
                Character
              </v-tab>
              <v-tab>
                Bonds &amp; XP
              </v-tab>
              <v-tab>
                Assets
              </v-tab>
              <v-tab>
                Progress
              </v-tab>
              <v-tab>
                Notes
              </v-tab>
            </v-tabs>
          </template>
        </v-toolbar>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <CharacterSheet />
          </v-tab-item>

          <v-tab-item>
            <Bonds />
          </v-tab-item>

          <v-tab-item>
            <Assets />
          </v-tab-item>

          <v-tab-item>
            <Progresses />
          </v-tab-item>

          <v-tab-item>
            <Notes />
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-bottom-sheet>

    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>

    <MovesDialog v-model="movesDialogOpen" />
    <OraclesDialog v-model="oraclesDialogOpen" />
    <MapDialog v-model="mapDialogOpen" />
  </v-app>
</template>

<script>
  import PrimaryNav from '@/components/PrimaryNav';

  import NewEntry from '@/components/NewEntry';
  import ProgressTrack from '@/components/ProgressTrack';
  import Notes from '@/components/Notes';

  import FooterMomentum from '@/components/FooterMomentum';
  import VitalsHeader from '@/components/VitalsHeader';
  import FooterStat from '@/components/FooterStat';
  import CharacterSheet from '@/components/CharacterSheet';
  import Bonds from '@/components/Bonds';
  import Assets from '@/components/Assets';
  import Progresses from '@/components/Progress';
  import MovesDialog from '@/components/MovesDialog';
  import OraclesDialog from '@/components/OraclesDialog';
  import MapDialog from '@/components/MapDialog';

  import {mapGetters} from 'vuex';

  export default {
    name: 'App',
    components: {
      PrimaryNav,
      NewEntry,
      VitalsHeader,
      FooterMomentum,
      FooterStat,
      CharacterSheet,
      Bonds,
      Assets,
      Progresses,
      MovesDialog,
      OraclesDialog,
      MapDialog,
      ProgressTrack,
      Notes,
    },

    computed: {
      ...mapGetters('progress', ['progressIsPinned', 'pinnedProgressTrack']),
      onPages() {
        return this.$route.name !== 'Home';
      },
    },

    created() {
      if (!this.$router.session) {
        this.sessionKey = this.$store.getters.sessionKey;
        this.$router.push({query: {session: this.sessionKey}});
        // TODO: Above line is throwing 'uncaught exception: Object'

        this.$store.dispatch('initializeSession'); // have to do this in order to
        // trigger the first persistedstate update.
      }

      // get moves
      this.$store.dispatch('move/initialize');
      // get oracles
      this.$store.dispatch('oracle/initialize');
    },
    data() {
      return {
        navOpen: null,
        tab: null,
        showCharacterSheet: false,
        movesDialogOpen: false,
        oraclesDialogOpen: false,
        mapDialogOpen: false,
        sessionKey: '',
      };
    },
    methods: {
      openMovesDialog() {
        this.movesDialogOpen = true;
      },
      openOraclesDialog() {
        this.oraclesDialogOpen = true;
      },
      openMapDialog() {
        this.mapDialogOpen = true;
      },
      actionRoll() {
        this.$store.dispatch('character/rollChallenge');
      },
    },
  };
</script>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
